import { connect, MapStateToProps } from 'react-redux';
import { getCoreLevel } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { Props } from './StorageCapacity';
import { AppState } from '../../types/store';

export type StateProps = Pick<Props, 'coreLevel'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => ({
  coreLevel: getCoreLevel(state),
});

export default connect(mapStateToProps);
